import { FailureStatusFilter } from "api/generated/lumen";
import useAuth from "features/auth/useAuth";
import { useMemo } from "react";
import { ListRequestParams } from "widgets/table/useTableUtils";
import FailuresTable from "../../default/FailuresTable";
import Claims from "features/auth/claims";

const TableToAttend: React.FC = () => {
  const { hasClaim } = useAuth();

  const fetchDataParams = useMemo<ListRequestParams>(() => {
    let params: any = {
      filter: {},
      statusFilter: FailureStatusFilter.OnlyOpened,
    };

    if (hasClaim([Claims.Failure.ReadOwn])) {
      params = {
        filter: {},
        statusFilter: FailureStatusFilter.OnlyOpened,
        onlyNotAssignedToRepairman: true,
      };
    }

    if (hasClaim([Claims.Failure.Read])) {
      params = {
        statusFilter: FailureStatusFilter.OnlyOpened,
        filter: {
          contractor: "", // Not assigned to contractor
        },
      };
    }

    return params;
  }, [hasClaim]);

  return (
    <FailuresTable
      fetchDataParams={fetchDataParams}
      failureListType="toAttend"
    />
  );
};

export default TableToAttend;
